import { Quest } from '../quest';

export class AvatarQuest extends Quest {
  detailKey = null;
}
